import React, { Fragment, useRef } from "react";
import _ from "lodash";
import RegisterFields from "../RegisterFields";
import approverFormFields from "./approverFormFields";

export const ApproverEditForm = ({ onChange, initailValues }) => {
  const inputRef = useRef({});

  const renderFields = () => {
    return _.map(approverFormFields, ({ label, name, type, options, required }) => {
      return (
        <RegisterFields
          key={name}
          name={name}
          label={label}
          type={type}
          value={inputRef.current.name}
          options={options}
          required={required}
          initailValue={initailValues[name]}
          onChange={onChange(name)}
        />
      );
    });
  };

  return <Fragment>{renderFields()}</Fragment>;
};
